import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './app/core/services/auth.interceptor';
import { APP_INITIALIZER } from '@angular/core';
import { DevAuthService, initializeDevAuth } from './app/core/services/dev-auth.service';

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    {
      // need to remove this
      provide: APP_INITIALIZER,
      useFactory: initializeDevAuth,
      deps: [DevAuthService],
      multi: true,
    },
  ]
});